import Role from '../../services/role'
import * as types from '../mutationTypes'

let state = {
  roles: [],
  error: null
}

const getters = {

  roles (state) {
    return state.roles.name
  },

  selectList (state) {
    return state.roles.map(r => {
      return { text: r.name, value: r.id }
    })
  }
}

const actions = {
  async loadRoles ({ commit }) {
    try {
      let res = await Role.get()
      if (res) {
        commit(types.REQUEST_ROLE_LIST_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_ROLE_LIST_ERROR, 'Error loading role list' + err)
    }
  }
}

const mutations = {

  [types.REQUEST_ROLE_LIST_SUCCESS] (state, roles) {
    state.roles = roles
    state.error = null
  },

  [types.REQUEST_ROLE_LIST_ERROR] (state, message) {
    state.roles = null
    state.error = message
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
